import script from "./ProjectBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectBoard.vue?vue&type=script&setup=true&lang=js"

import "./ProjectBoard.vue?vue&type=style&index=0&id=03e945f6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e945f6"]])

export default __exports__